import { render } from "./AppConfiguration.vue?vue&type=template&id=235dbd42&scoped=true"
import script from "./AppConfiguration.vue?vue&type=script&lang=js"
export * from "./AppConfiguration.vue?vue&type=script&lang=js"

import "./AppConfiguration.vue?vue&type=style&index=0&id=235dbd42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235dbd42"]])

export default __exports__